export const Result = {
    ok: <T>(data: T) => ({
        ok: true,
        data,
        err: null
    } as const),
    err: <T>(err: T) => ({
        ok: false,
        data: null,
        err
    } as const)
}

export function sleep(milliseconds: number): Promise<undefined> {
    return new Promise((resolve) => setTimeout(resolve, milliseconds))
}

export function friendlyPhone(phoneNumberString: string): string {
    const cleaned = ("" + phoneNumberString).replace(/\D/g, "")
    // what the hell does this even do?
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
    if (!match) {
        return "000-000-0000"
    }
    const intlCode = match[1] ? "+1 " : ""
    const phoneParts = [
        intlCode, 
        "(", match[2], ") ", 
        match[3], "-", match[4]
    ]
    return phoneParts.join("")
}

export function roundDecimal(
    decimal: number, places: number
): number {
    const factor = 10 ** Math.max(places, 1)
    return Math.round(decimal * factor) / factor
}